import MinusRoundedSvg from '@app/shared/icons/MinusRounded';
import { l } from '@locale/setupI18n';
import Button from '@app/shared/components/button/Button';
import { ButtonAppearance, ButtonSize } from '../button/button-enums';
import SvgArrowLeft from '@app/shared/icons/ArrowLeft';
import SvgArrowRight from '@app/shared/icons/ArrowRight';
import { ShiftDirection } from '@app/modules/projects/inputs/capital-structure/tabs/equity-bridge-tab/utils/equityBridgeTableHelper';

interface ColumnControlsProps {
  onDelete: () => void;
  onShift: (direction: ShiftDirection) => void;
  canShift: (direction: ShiftDirection) => boolean;
}

const ColumnControls: React.FC<ColumnControlsProps> = ({
  onDelete,
  onShift,
  canShift,
}: ColumnControlsProps) => (
  <th className="table-primary__cell--header table-primary__cell--right">
    <div
      style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'space-around' }}>
      <div>
        <Button
          appearance={ButtonAppearance.LINK}
          onClick={() => onShift(ShiftDirection.Left)}
          disabled={!canShift(ShiftDirection.Left)}>
          <SvgArrowLeft height="14px" color={canShift(ShiftDirection.Left) ? '#D04A02' : 'gray'} />
        </Button>
      </div>

      <Button
        appearance={ButtonAppearance.CLEAN}
        size={ButtonSize.TABLE_ACTION}
        title={l('_DeleteItem')}
        onClick={onDelete}>
        <MinusRoundedSvg />
      </Button>
      <div>
        <Button
          onClick={() => onShift(ShiftDirection.Right)}
          appearance={ButtonAppearance.LINK}
          disabled={!canShift(ShiftDirection.Right)}>
          <SvgArrowRight
            height="14px"
            color={canShift(ShiftDirection.Right) ? '#D04A02' : 'gray'}
          />
        </Button>
      </div>
    </div>
  </th>
);

export default ColumnControls;
